import BaseComponent from "../../../baseComponent.js";
import styles from "./styles.scss";

export default class MinMax extends BaseComponent {
  constructor(props) {
    super(props);
  }

  render() {
    let min, max, label = "";
    if (this.props.min != null) {
      label = "Min";
      min = <input type="number"
                   placeholder="Min"
                   value={this.props.min}
                   onChange={(e) => this.props.onLegendChange("min", e.target.value, true)}/>;
    }

    if (this.props.max != null) {
      label = label.length > 0 ? label + " / Max" : "Max";
      max = <input type="number"
                   placeholder="Max"
                   value={this.props.max}
                   onChange={(e) => this.props.onLegendChange("max", e.target.value, true)}/>;
    }

    return (
      <div className={styles.minMax}>
        <div className={styles.configLine}>
          <div className={styles.configLabel}>{this.props.label || label}</div>
          {min}
          {max}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/add-widget/legend-config/minMax.jsx